<template>
  <div>
    <b-modal
      v-model="modalShow"
      size="xl"
      centered
      no-close-on-backdrop
      no-close-on-esc
    >
      <template #modal-header>Print</template>
      <div>
        <b-row class="px-2">
          <!-- <b-col cols="12">
            <b-form-checkbox
              v-model="form.is_change_sale_status"
              :value="1"
              :unchecked-value="0"
            >
              เอาเฉพาะ Sale Status เปลี่ยน
            </b-form-checkbox>
            <b-form-checkbox
              v-model="form.is_change_price"
              :value="1"
              :unchecked-value="0"
              class="mt-2"
              >เอาเฉพาะ ราคา เปลี่ยน
            </b-form-checkbox>
          </b-col> -->
          <b-col
            :cols="prints.length > 1 ? 6: 12"
            
            v-for="item in prints"
            :key="item.id"
            class="text-center p-2"
          >
            <div
              class="card card-print d-flex align-items-center justify-content-center"
              @click="exportPdf(item)"
            >
              {{ item.name }}
            </div>
          </b-col>
        </b-row>
      </div>

      <template #modal-footer>
        <div class="w-100 d-flex justify-content-between">
          <b-button @click.prevent="hide" class="border-btn">Cancel</b-button>
        </div>
      </template>
    </b-modal>
  </div>
</template>
<script>
export default {
  components: {},
  props: {
    formExport: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      prints: [],
      modalShow: false,
      form: {
        // is_change_sale_status: 0,
        // is_change_price: 0,
      },
    };
  },
  methods: {
    async show() {
      this.$bus.$emit("showLoading");
      // this.form = {
      //   is_change_sale_status: 0,
      //   is_change_price: 0,
      // };
      const res = await this.axios(`/setting/GetTemplates/3`);
      this.prints = res.data.detail;
      this.$bus.$emit("hideLoading");
      this.modalShow = true;
    },

    hide() {
      this.modalShow = false;
    },
    async exportPdf(item) {
      this.$bus.$emit("showLoading");
      this.formExport.date = this.formExport.date
        ? this.$moment(this.formExport.date)
            .add(543, "years")
            .format("DD/MM/YYYY")
        : "";
      this.formExport.duedate = this.formExport.duedate
        ? this.$moment(this.formExport.duedate)
            .add(543, "years")
            .format("DD/MM/YYYY")
        : "";

      try {
        const res = await this.axios.post(
          `/CoverSheet/Export`,
          {
            id: item.id,
            user_guid: this.$cookies.get("print_tag_admin_user_guid"),
            ...this.form,

            ...this.formExport,
          },
          {
            responseType: "blob",
          }
        );
        const blob = new Blob([res.data], { type: "application/xlsx" });
        const url = window.URL.createObjectURL(blob);
        const link = document.createElement("a");
        link.href = url;
        const now = new Date();
        const dd = String(now.getDate()).padStart(2, "0");
        const mm = String(now.getMonth() + 1).padStart(2, "0"); // ม.ค. = 0
        const yyyy = now.getFullYear();
        const filename = `${item.name}_${dd}${mm}${yyyy}.xlsx`;

        link.download = filename;

        document.body.appendChild(link);
        link.click();
        link.remove();
        window.URL.revokeObjectURL(url);
        this.$emit("success");
        this.$bus.$emit("hideLoading");
        this.hide();
      } catch (error) {
        this.$bus.$emit("hideLoading");
        console.error("Export PDF error:", error);
        this.errorAlert("ไม่สามารถดาวน์โหลดไฟล์ได้");
      }
    },
  },
};
</script>
<style lang="scss">
.card-print {
  border-color: var(--primary-color);
  height: 100px;
  color: var(--primary-color);
  text-align: center;
  font-size: 20px;
  font-weight: bold;
  border-radius: 10px;
}

.select {
  background-color: var(--primary-color);
  color: white;
  cursor: pointer;
}

.card-print:hover {
  background-color: var(--primary-color);
  color: white;
  cursor: pointer;
}
</style>
